import React, { useEffect, useState } from 'react';
import { getFwvPostEP, getPostData } from '@vfit/consumer/hooks';
import { errorManager, ErrorService } from '@vfit/shared/data-access';
import HiddenPostForm from '../../HiddenPostForm/hiddenPostForm';

const EnergyContainer = () => {
  const [postData, setPostData] = useState({
    isEnabled: false,
    url: getFwvPostEP(),
    msisdn: '',
    account: '',
    checksum: '',
  });

  const managePostEnrg = () => {
    const { msisdn, checksum, account } = getPostData?.() || {};
    if (!msisdn || !account) {
      errorManager.handleError(ErrorService.getSeverityErrorHigh(), {
        title: 'Ops',
        message: 'Si è verificato un problema. Riprovare in seguito',
        actionText: 'Chiudi',
        fullscreen: true,
        disableCloseModalOnClickAction: true,
      });
      return;
    }
    setPostData({
      ...postData,
      isEnabled: true,
      msisdn,
      account,
      ...(checksum && { checksum }),
    });
  };

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.addEventListener('enrgServiceNotificationEvent', managePostEnrg);
    }
    return () => document.removeEventListener('enrgServiceNotificationEvent', managePostEnrg);
  }, []);

  if (!postData?.isEnabled) return;

  return (
    <HiddenPostForm
      url={postData.url}
      params={{
        msisdn: {
          name: 'msisdn',
          value: postData?.msisdn || '',
        },
        account: {
          name: 'account',
          value: postData?.account || '',
        },
        checksum: {
          name: 'checksum',
          value: postData?.checksum || '',
        },
      }}
    />
  );
};

export default EnergyContainer;
